import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Home, CalendarDays, Pill, AlertCircle, MessageSquare, Bell, Settings } from "lucide-react";

const NAV = [
  { to: "/m",               icon: Home,          label: "Home", end: true },
  { to: "/m/appointments",  icon: CalendarDays,  label: "Appointments" },
  { to: "/m/medication",    icon: Pill,          label: "Medication" },
  { to: "/m/effects",       icon: AlertCircle,   label: "Side Effects" },
  { to: "/m/messages",      icon: MessageSquare, label: "Messages" },
  { to: "/m/notifications", icon: Bell,          label: "Alerts" },
  { to: "/m/settings",      icon: Settings,      label: "Settings" },
];

export default function PatientShell() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="min-h-screen bg-stone-50 pb-24" data-testid="patient-shell">
      <Outlet />
      <nav className="patient-bottom-nav fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 z-40 shadow-[0_-4px_12px_rgba(0,0,0,0.04)] pb-safe">
        <div className="max-w-2xl mx-auto grid grid-cols-7">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center py-2.5 text-[10px] gap-0.5 transition-colors ${
                  isActive ? "text-brand-700" : "text-stone-500 hover:text-stone-800"
                }`
              }
            >
              <n.icon className="w-5 h-5" />
              <span className="font-medium leading-tight">{n.label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
